var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#3D405B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.997 16.0001V15.9996H16V11.5986C16 9.44561 15.5365 7.78711 13.0195 7.78711C11.8095 7.78711 10.9975 8.45111 10.666 9.08061H10.631V7.98811H8.24451V15.9996H10.7295V12.0326C10.7295 10.9881 10.9275 9.97811 12.221 9.97811C13.4955 9.97811 13.5145 11.1701 13.5145 12.0996V16.0001H15.997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.198 7.98828H6.686V15.9998H4.198V7.98828Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.441 4C4.6455 4 4 4.6455 4 5.441C4 6.2365 4.6455 6.8955 5.441 6.8955C6.2365 6.8955 6.882 6.2365 6.882 5.441C6.8815 4.6455 6.236 4 5.441 4V4Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6ec76899.svg";
export { ForwardRef as ReactComponent };